// extracted by mini-css-extract-plugin
export default {"main":"_8c34a80a6b _1eb49134f1","xmark":"_5258b355f7","fl_img":"_90f8e753f3 _13448ca5bd"};